if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getVariantData() {
        const premiumSection = this.closest('[id^="PremiumProduct-"]');
        if (premiumSection) {
          const premiumJson = premiumSection.querySelector('script[id^="PremiumVariantsJSON-"]');
          if (premiumJson) {
            try {
              return JSON.parse(premiumJson.textContent);
            } catch (e) {
              console.error('Error parsing PremiumVariantsJSON', e);
            }
          }
        }

        const variantJson =
          this.querySelector('variant-selects script[type="application/json"]') ||
          this.querySelector('variant-radios script[type="application/json"]') ||
          this.closest('section')?.querySelector('variant-selects script[type="application/json"]') ||
          this.closest('section')?.querySelector('variant-radios script[type="application/json"]');

        if (variantJson) {
          try {
            return JSON.parse(variantJson.textContent);
          } catch (e) {
            console.error('Error parsing variant JSON', e);
          }
        }

        return [];
      }

      getSelectedOptions() {
        const selectedOptions = [];
        const processedNames = [];

        this.form.querySelectorAll('input[name^="options["], select[name^="options["]').forEach((field) => {
          if (processedNames.includes(field.name)) return;
          processedNames.push(field.name);

          if (field.tagName === 'SELECT') {
            selectedOptions.push(field.value);
            return;
          }

          const checkedField = this.form.querySelector(`input[name="${field.name}"]:checked`);
          if (checkedField) {
            selectedOptions.push(checkedField.value);
          }
        });

        return selectedOptions;
      }

      getSelectedVariant() {
        const variants = this.getVariantData();
        const selectedOptions = this.getSelectedOptions();

        if (!variants.length || !selectedOptions.length) return null;

        return (
          variants.find((variant) => {
            if (!variant.options || variant.options.length !== selectedOptions.length) return false;

            return variant.options.every((option, index) => {
              return String(option) === String(selectedOptions[index]);
            });
          }) || null
        );
      }

      syncVariantId() {
        const selectedVariant = this.getSelectedVariant();
        if (!selectedVariant) return null;

        const idInput = this.form.querySelector('[name=id]');
        if (idInput) {
          idInput.value = selectedVariant.id;
          idInput.disabled = false;
        }

        return selectedVariant;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.syncVariantId();

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}